import { useWidgetPostMessages } from '@widgets/messenger/utils/postMessages'

export type PublicWidgetEventType = 'emailFormSubmit'

export interface PublicWidgetEventPayload {
  eventType: PublicWidgetEventType
}

export const usePublicWidgetEventMessages = <T extends PublicWidgetEventPayload>(widgetId: string) =>
  useWidgetPostMessages<T>(widgetId, 'textmagicPublicEvent')

export const sendEmailFormSubmitMessage = (widgetId: string) => {
  usePublicWidgetEventMessages(widgetId).sendToParent({
    eventType: 'emailFormSubmit',
  })
}
